import React, { Fragment } from "react";
import { IProps } from "./interfaces";
import { Line, Circle } from "./styles";

export const unitWidth = 64;

const Grid = ({ width }: IProps) => (
    <>
        {width.map((w, i) => (
            <Fragment key={i}>
                <Line
                    x1={unitWidth * 2}
                    y1={unitWidth * 2}
                    x2={unitWidth * 2 + w * unitWidth}
                    y2={unitWidth * 2 - w * unitWidth}
                />
                <Circle cx={unitWidth * 2 + w * unitWidth} cy={unitWidth * 2 - w * unitWidth} r={6} />
                {(w === 1 || w === -1) && <Circle cx={unitWidth * 2} cy={unitWidth * 2} r={6} />}

            </Fragment>
        ))}
    </>
);



export default Grid;
